import { render, staticRenderFns } from "./TheRankingPreferenceTh.vue?vue&type=template&id=a92a7224&scoped=true&lang=pug&"
import script from "./TheRankingPreferenceTh.vue?vue&type=script&lang=js&"
export * from "./TheRankingPreferenceTh.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a92a7224",
  null
  
)

export default component.exports